"use client";

import DaumPostcodeEmbed from "react-daum-postcode";
import type { DaumPostcodeData } from "@/types/address";

interface Props {
  onComplete: (data: DaumPostcodeData) => void;
  onClose: () => void;
}

export default function AddressSearchEmbed({ onComplete, onClose }: Props) {
  const handleComplete = (data: DaumPostcodeData) => {
    let fullAddress = data.address;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname) extraAddress += data.bname;
      if (data.buildingName) {
        extraAddress += extraAddress ? `, ${data.buildingName}` : data.buildingName;
      }
      if (extraAddress) {
        fullAddress += ` (${extraAddress})`;
      }
    }

    onComplete({ ...data, address: fullAddress } as DaumPostcodeData);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center">
      <div className="bg-white w-full sm:max-w-md sm:rounded-xl overflow-hidden max-h-[90vh] flex flex-col">
        {/* 헤더 */}
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h3 className="font-bold text-base">주소 검색</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl leading-none"
          >
            ✕
          </button>
        </div>

        {/* 카카오 우편번호 임베드 */}
        <div className="w-full h-[70vh] sm:h-[500px]">
          <DaumPostcodeEmbed
            onComplete={handleComplete}
            style={{ width: "100%", height: "100%" }}
            autoClose={false}
          />
        </div>
      </div>
    </div>
  );
}
